// LoginUtils.ts

import marketPlaceConfig from "@/app/config/client-assets-config/marketplace/client-config";
import { Config, LoginFlow } from "@thriwe-2-0/thriwe-ui-utils";
import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";
import LoginWithOtp from "../../workflow/login-with-otp";
import LoginWithPassword from "../../workflow/login-with-password";

export function renderLoginComponent(config: Config | undefined) {
  const loginConfig = config?.login;

  switch (loginConfig?.loginFlow) {
    case LoginFlow.LOGIN_WITH_MOBILE_EMAIL_OTP:
      return (
        <LoginWithOtp
          termsAndCondition={marketPlaceConfig?.login?.termAndConditionCheckbox}
          islogin={true}
        />
      );
    case LoginFlow.LOGIN_REGISTER_WITH_MOBILE_OTP:
      return (
        <LoginWithOtp
          termsAndCondition={marketPlaceConfig?.login?.termAndConditionCheckbox}
          islogin={true}
        />
      );

    case LoginFlow.LOGIN_WITH_MOBILE_EMAIL_PASSWORD:
      return <LoginWithPassword />;
  }
}

export function checkAndRedirectToLanding(
  config: Config | undefined,
  router: AppRouterInstance
) {
  if (config?.withoutDialogLogin) {
    router.push("/landing");
    return <div></div>;
  }
}

export function checkAndRedirectToLogin(
  config: Config | undefined,
  router: AppRouterInstance
) {
  if (!config?.withoutDialogLogin) {
    router.push("/login");
    return <div></div>;
  }
}
